import { render } from "./DriverNotifications.vue?vue&type=template&id=0ad786bb"
import script from "./DriverNotifications.vue?vue&type=script&lang=js"
export * from "./DriverNotifications.vue?vue&type=script&lang=js"
script.render = render

export default script